<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="width"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="产品代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            show-search
            placeholder="请选择产品代码"
            :showSearch="true"
            optionFilterProp="label"
            @change="codeChange"
            v-decorator="[
              'fundCode',
              {
                rules: [{ required: true, message: '请选择产品代码' }]
              }
            ]"
          >
            <a-select-option
              :label="item.fundCode"
              v-for="(item, index) in fundList"
              :key="item.fundCode + '_' + index"
            >
              {{ item.fundCode }}/{{ item.fundName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="产品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            disabled
            placeholder="请输入产品名称"
            v-decorator="[
              'fundName',
              {
                rules: [{ required: true, message: '请选择产品名称' }]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="推荐理由"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :maxLength="6"
            v-decorator="['reason', validatorRules.reason]"
            rows="4"
            placeholder="请输入推荐理由"
          />
        </a-form-item>
        <a-form-item
          label="发布渠道栏目"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-tree-select
            size="large"
            style="width: 500px"
            :tree-data="columnChannel"
            tree-checkable
            @change="onChangeColumnChannel"
            placeholder="请选择发布渠道栏目"
            v-decorator="['channelColumnList', validatorRules.columnName]"
          />
        </a-form-item>
        <a-form-item
          label="索引排序"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            v-decorator="['indexSort', validatorRules.indexSort]"
            :min="1"
          />
        </a-form-item>
        <a-form-item
          label="选择展示业绩"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-checkbox-group
            style="width: 100%"
            v-decorator="[
              'dispPointer',
              {
                rules: [{ required: true, message: '请选择展示业绩' }]
              }
            ]"
            @change="onChange"
          >
            <a-row>
              <a-col :span="12" v-for="item in pointerList" :key="item.value">
                <a-checkbox :value="item.value"> {{ item.text }} </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import { ajaxGetDictItems } from '@/api/api';
import { validateDuplicateValue } from '@/utils/util';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { queryFundCode } from '@/api/api';
import { getAction, postTag } from '@/api/manage';
import { findTreeNodeArray } from '@/utils/common';
export default {
  name: 'ProductsRecommendedModal',
  components: {
    JDictSelectTag
  },
  props: ['columnChannel'],
  data() {
    return {
      pointerList: [],
      columnList: [],
      fundList: [],
      typeList: [],
      channel: [],
      channelName: [],
      code: [],
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        fundCode: {
          rules: [
            { required: true, message: '请输入产品代码!' },
            {
              validator: (rule, value, callback) =>
                validateDuplicateValue(
                  'products_recommended',
                  'fund_code',
                  value,
                  this.model.id,
                  callback
                )
            }
          ]
        },
        fundName: {
          rules: [{ required: true, message: '请输入产品名称!' }]
        },
        reason: {
          rules: [{ required: true, message: '请输入推荐理由!' }]
        },
        recommendBit: {
          rules: [{ required: true, message: '请输入推荐位!' }]
        },
        indexSort: {
          rules: [{ required: true, message: '请输入索引排序!' }]
        },
        columnName: {
          rules: [{ required: true, message: '请选择栏目!' }]
        }
      },
      url: {
        save: process.env.VUE_APP_CMS_PRODUCT + '/product/recommended/save',
        // edit: process.env.VUE_APP_CMS_PRODUCT + '/product/recommended/edit',
        list: process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel'
      }
    };
  },
  created() {
    this.initFundList();
    this.getFigureList();
  },
  methods: {
    getFigureList() {
      let code = 'net_value_type';
      ajaxGetDictItems(code).then(res => {
        if (res.success) {
          this.pointerList = res.result;
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    initFundList() {
      queryFundCode().then(res => {
        if (res.success) {
          this.fundList = res.result ? res.result : [];
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    codeChange(value) {
      let key = value.split('_')[0];
      let target = this.fundList.find(item => item.fundCode == key);
      let fundName = target.fundName;
      let fundCode = target.fundCode;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          fundName,
          fundCode
        });
      });
      this.initFundList();
    },
    onChangeColumnChannel(value, label, code) {
      this.columnList = value;
      // this.columnList = [];
      // value.forEach((item, index) => {
      //   let obj = {};
      //   obj.channelName = label[index];
      //   obj.columnId = item;
      //   obj.columnName = label[index];
      //   this.columnList.push(obj);
      // });
      // this.channel = value;
      // this.channelName = label;
      // console.log(value, label, code);
    },
    add() {
      this.edit({});
    },
    edit(record) {
      console.warn(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('+++++++', this.model);
      if (record.dispPointer) {
        this.model.dispPointer = this.model.dispPointer.split(',');
      } else {
        this.model.dispPointer = [];
        // this.model.dispPointer.push('yearGrothRate');
      }
      this.visible = true;
      this.channelName = [];
      this.columnList = [];
      this.channel = [];
      if (record.columnCode) {
        this.channelName = record.columnName.split(',');
        this.channel = record.columnCode.split(',');
      }
      //this.columnList = record.recommendedSubs;
      let columnIds = [];
      if (record.recommendedSubs != null) {
        record.recommendedSubs.map(item => {
          columnIds.push(item.columnId);
        });
      }
      this.columnList = columnIds;

      // let arr = [];
      // if (record.channelColumnList && record.channelColumnList.length > 0) {
      //   record.channelColumnList.forEach((item) => {
      //     arr.push(item.columnId);
      //   });
      // }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'fundCode',
            'fundName',
            'reason',
            'recommendBit',
            'indexSort',
            'recommendType',
            'typeName',
            'dispPointer'
          )
        );

        this.form.setFieldsValue({
          columnName: this.channel,
          channelColumnList: columnIds
        });
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          console.warn(values);
          let formData = Object.assign(that.model, values);
          formData.dispPointer = `${formData.dispPointer}`;
          formData.recommendedSubs = this.handleChannelData(); //this.columnList;

          // formData.columnName = that.channelName.join(',');
          // formData.columnCode = that.channel.join(',');
          let url = '';
          // if (formData.id) {
          //   url = that.url.edit;
          // } else {
          url = that.url.save;
          // }
          postTag(url, formData).then(res => {
            that.confirmLoading = false;
            that.close();
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },

    onChange(checkedValues) {
      console.log('checked = ', checkedValues);
      if (checkedValues.length > 2) {
        this.form.setFieldsValue({ dispPointer: checkedValues.splice(0, 1) });
        console.log(checkedValues);
      }
    },
    handleChannelData() {
      let arr = findTreeNodeArray('children', this.columnChannel, e => {
        return this.columnList.filter(item => item == e.id).length > 0;
      });
      console.log('arr++++++', arr);
      let list = [];
      arr.forEach(item => {
        let obj = {};
        obj.columnName = item.name;
        (obj.columnCode = item.code), (obj.channelCode = item.channelCode);
        obj.columnId = item.value;
        list.push(obj);
      });
      return list;
    },
    handleSearch(value) {
      let arr = [];
      this.fundList.forEach(item => {
        if (
          item.fundCode.indexOf(value) > -1 ||
          item.fundName.indexOf(value) > -1
        ) {
          arr.push(item);
        }
      });
      this.fundList = arr;
    }
  }
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
